$.ready(function() {
	var pays = game.pays;
	
	pays.colors = [ [ 255, 0, 0 ], [ 255, 255, 0 ], [ 0, 255, 0 ], [ 0, 255, 255 ], [ 0, 0, 255 ], [ 255, 0, 255 ] ];
	
	pays.getPosition = function(reel, row, offsetY) {
		var x;
		var y;
		var width;
		var height;
		
		if (typeof offsetY === 'undefined') {
			x =  game.frame.reels[reel].el.offsetLeft;
			x += game.frame.reels[reel].symbols[row].el.offsetLeft;
			
			y =  game.frame.reels[reel].el.offsetTop;
			y += game.frame.reels[reel].symbols[row].el.offsetTop;
			
			width = game.frame.reels[reel].symbols[row].el.offsetWidth;
			height = game.frame.reels[reel].symbols[row].el.offsetHeight;
			
			return [ x, y, width, height ];
		}
		
		else {
			x =  game.frame.reels[reel].el.offsetLeft;
			x += game.frame.reels[reel].symbols[row].el.offsetLeft;
			x += game.frame.reels[reel].symbols[row].el.offsetWidth / 2;
			
			y =  game.frame.reels[reel].el.offsetTop;
			y += game.frame.reels[reel].symbols[row].el.offsetTop;
			y += game.frame.reels[reel].symbols[row].el.offsetHeight * (offsetY || 0);
			
			return [ x, y ];
		}
	};
	
	pays.drawLines = function(lines) {
		if (!pays.lines) {
			return;
		}
		
		var counts = [];
		var offsets = {};
		
		function process(line) {
			offsets[line] = [];
			
			for (var reel = 0; reel < pays.lines[line].length; reel++) {
				var row = pays.lines[line][reel];
				
				if (!counts[reel]) {
					counts[reel] = [];
				}
				
				if (!counts[reel][row]) {
					counts[reel][row] = 0;
				}
				
				offsets[line][reel] = counts[reel][row];
				counts[reel][row]++;
			}
		}
		
		function processPost(line) {
			offsets[line] = {
				counts: offsets[line],
				offsets: [],
			};
			
			for (var reel = 0; reel < pays.lines[line].length; reel++) {
				var row = pays.lines[line][reel];
				offsets[line].offsets[reel] = (offsets[line].counts[reel] + 1) / (counts[reel][row] + 1);
			}
		}
		
		this.canvas.shadowOffsetX = 0;
		this.canvas.shadowOffsetY = 4;
		this.canvas.shadowBlur = 4;
		this.canvas.shadowColor = 'black';
		
		var line;
		
		if (typeof lines === 'number') {
			for (line = 0; line < lines; line++) {
				process(line);
			}
			
			for (line = 0; line < lines; line++) {
				processPost(line);
			}
			
			for (line = 0; line < lines; line++) {
				this.drawLine(line, offsets[line].offsets);
			}
		}
		
		else {
			for (line in lines) {
				process(lines[line]);
			}
			
			for (line in lines) {
				processPost(lines[line]);
			}
			
			for (line in lines) {
				this.drawLine(lines[line], offsets[lines[line]].offsets);
			}
		}
	};
	
	pays.drawLine = function(lineNumber, offset, pay) {
		this.canvas.beginPath();
		this.canvas.strokeStyle = this.getColor(lineNumber, pays.lines.length);
		
		var line = pays.lines[lineNumber];
		
		for (var reel = 0; reel < line.length; reel++) {
			var row = line[reel];
			
			var point = {
				reel: reel,
				line: line,
				lineNumber: lineNumber,
				pay: pay,
			};
			
			point.track = game.frame.reels[reel].symbols[row];
			
			if (reel === 0 || reel === line.length - 1) {
				point.offset = pays.canvas.lineWidth;
			}
			
			this.trigger('line', point);
			
			point.x =  game.frame.reels[reel].el.offsetLeft;
			point.x += game.frame.reels[reel].symbols[row].el.offsetLeft;
			point.x += game.frame.reels[reel].symbols[row].el.offsetWidth / 2;
			
			point.y =  game.frame.reels[reel].el.offsetTop;
			point.y += point.track.el.offsetTop;
			point.y += point.track.el.offsetHeight * ((offset && typeof offset[reel] === 'number') ? offset[reel] : 0.5);
			
			if (reel === 0) {
				this.canvas.moveTo(point.offset, point.y);
			}
			
			this.canvas.lineTo(point.x, point.y);
			
			if (reel === line.length - 1) {
				this.canvas.lineTo(pays.canvas.canvas.offsetWidth - point.offset, point.y);
			}
		}
		
		this.canvas.stroke();
	};
	
	pays.getColor = function(point, max, rgba) {
		var w = max / this.colors.length;
		var g = (point % w) / w;
		var m = Math.floor((point % max) / w);
		var n = (m + 1) % this.colors.length;
		
		var rgb = [
			Math.floor(g * (this.colors[n][0] - this.colors[m][0]) + this.colors[m][0]),
			Math.floor(g * (this.colors[n][1] - this.colors[m][1]) + this.colors[m][1]),
			Math.floor(g * (this.colors[n][2] - this.colors[m][2]) + this.colors[m][2]),
		];
		
		if (typeof rgba !== 'undefined') {
			rgb.push(rgba);
			
			return 'rgba(' + rgb.join(',') + ')';
		}
		
		else {
			/* jshint -W016 */
			return '#' + ((1 << 24) + (rgb[0] << 16) + (rgb[1] << 8) + rgb[2]).toString(16).slice(1);
			/* jshint +W016 */
		}
	};
});



/** WEBPACK FOOTER **
 ** /Users/kevinduarte/SG/roc2/plugins/slot/public-src/common/js/container-pays-utils.js
 **/